import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { useAuth } from '../context/AuthProvider';

export const UnprotectedRoute: React.FC = () => {
  const { currentUser, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (currentUser?.member) {
    return <Navigate to={'/'} replace />;
  }

  return <Outlet />;
};
